import Moment from 'moment'

class dateTimeHelper {
  static readableDate (value) {
    return Moment(value).format('MMM D, YYYY')
  }

  static readableTime (value) {
    return Moment(value).format('h:mm:ss A')
  }

  static readableDateTime (value) {
    return Moment(value).format('MMM D, YYYY | h:mm:ss A')
  }
}

export default dateTimeHelper
